import { Button, Interpolate } from '@wg/wows-react-uikit';
import { useTranslation } from 'react-i18next';
import styles from '~/Components/StartBundle/StartBundle.scss';
import { NotEnouthMoney } from '~/Components/Messages/Messages';
import { gold as wowsEntityGold } from '~/wowsEntities';

interface FooterStartBundle_Props {
    isMobileDevice: boolean,
    isLocked: boolean,
    isBought: boolean,
    isBuyButtonDisabled: boolean,
    count: number,
    openBuyDialog: () => void,
    notEnoughMoney: boolean,
    needGold: number,
    price: number,
}

const FooterStartBundle = (props: FooterStartBundle_Props) => {
    const { t } = useTranslation();
    const {
        isMobileDevice, isLocked, isBought, count, openBuyDialog, isBuyButtonDisabled, notEnoughMoney, needGold, price
    } = props;
    const buyButtonVisible = !isBought && !isLocked;
    const priceComponent = wowsEntityGold(price, !isMobileDevice);

    return (
        <div className={styles.bottomWrapper}>
            {isLocked ? <div className={styles.lockIcon} /> : null}
            <div className={styles.price}>
                <Interpolate str={t('Стоимость %(stageCount)s этапов: %(price)s', { count })} stageCount={count} price={priceComponent} />
            </div>
            {buyButtonVisible && (
                <div className={styles.buyButton}>
                    <Button
                        type={'orange'}
                        isFlat={true}
                        onClick={openBuyDialog}
                        isDisabled={isBuyButtonDisabled}
                        tooltipContent={notEnoughMoney ? <NotEnouthMoney needGold={needGold} /> : undefined}
                    >
                        {t('Приобрести')}
                    </Button>
                </div>
            )}
        </div>
    );
};

export default FooterStartBundle;
